<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisField from 'dashboard/components-next/LaisField.vue';
import NucleoWorkOrderRequestServiceItem from './NucleoWorkOrderRequestServiceItem.vue';

const props = defineProps({
  errors: { type: Object, default: () => ({}) },
  form: { type: Object, required: true },
  serviceEntry: { type: Function, required: true },
  serviceTypes: { type: Array, default: () => [] },
});
const emit = defineEmits(['setCount', 'updateService']);
const { t } = useI18n();
const quantities = Array.from({ length: 10 }, (_, index) => index + 1);
const updateService = (...args) => emit('updateService', ...args);
</script>

<template>
  <div class="grid gap-5">
    <LaisCard
      :title="t('NUCLEO_WORK_ORDERS.REQUEST.SERVICES.TITLE')"
      prefix-icon="i-lucide-list-plus"
    >
      <p class="mb-4 text-sm text-lais-text-body">
        {{ t('NUCLEO_WORK_ORDERS.REQUEST.SERVICES.DESCRIPTION') }}
      </p>
      <LaisField
        :label="t('NUCLEO_WORK_ORDERS.REQUEST.SERVICES.QUANTITY')"
        :error="errors.services"
        required
      >
        <select
          :value="form.quantidade_servicos"
          class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
          @change="emit('setCount', $event.target.value)"
        >
          <option value="">
            {{ t('NUCLEO_WORK_ORDERS.REQUEST.FIELDS.SELECT') }}
          </option>
          <option
            v-for="quantity in quantities"
            :key="quantity"
            :value="quantity"
          >
            {{ quantity }}
          </option>
        </select>
      </LaisField>
    </LaisCard>

    <NucleoWorkOrderRequestServiceItem
      v-for="(service, index) in form.servico"
      :key="index"
      :errors="errors"
      :index="index"
      :service="service"
      :service-entry="serviceEntry"
      :service-types="props.serviceTypes"
      @update-service="updateService"
    />
  </div>
</template>
